import { createContext, useContext, type ReactNode } from 'react';

export type RouteTitleResolver = (pathname: string) => string | undefined;

const RouteTitleResolverContext = createContext<RouteTitleResolver>(() => undefined);

export function RouteTitleResolverProvider({
  children,
  resolve,
}: {
  children: ReactNode;
  resolve: RouteTitleResolver;
}) {
  return (
    <RouteTitleResolverContext.Provider value={resolve}>{children}</RouteTitleResolverContext.Provider>
  );
}

export function useRouteTitleResolver(): RouteTitleResolver {
  return useContext(RouteTitleResolverContext);
}
